/**
 * 批量导入部门翻译 - 中文
 * Batch Import Departments Translations - Chinese
 */
export const batchImportDeptZh = {
  // 对话框
  title: '批量导入部门',
  dialogTitle: '批量导入部门',
  
  // 步骤
  steps: {
    title: '导入步骤',
    step1: '下载部门导入模板',
    step2: '按照模板格式填写部门信息',
    step3: '上传填写好的文件',
    step4: '确认无误后提交导入',
  },
  
  // 模板相关
  template: {
    title: '模板说明',
    downloadBtn: '下载模板',
    downloading: '下载中...',
    downloaded: '模板已下载',
    fields: {
      name: '部门名称',
      nameDesc: '必填，部门的名称',
      code: '部门编码',
      codeDesc: '必填，唯一标识，大写字母、数字、下划线或连字符',
      parentCode: '上级编码',
      parentCodeDesc: '可选，填写上级部门的编码',
      description: '部门描述',
      descriptionDesc: '可选，部门的详细描述',
      order: '排序',
      orderDesc: '可选，数字，用于排序显示',
    },
    autoCodeTip: '💡 提示：上级编码留空表示顶级部门',
  },

  // 上传相关
  upload: {
    title: '上传文件',
    required: '上传文件 *',
    placeholder: '点击选择文件或拖拽文件到此处',
    reselect: '点击重新选择文件',
    formatHint: '支持 .xlsx、.xls、.csv 格式',
    parsing: '解析中...',
    parseSuccess: '文件解析成功，共 {count} 条有效数据',
    parseWarning: '文件解析完成，发现 {count} 条无效数据',
    parseFailed: '文件解析失败，请检查文件格式',
  },

  // 表格
  table: {
    deptName: '部门名称',
    deptCode: '部门编码',
    parentCode: '上级编码',
    description: '描述',
    order: '排序',
    error: '错误信息',
    noParent: '顶级部门',
  },

  // 数据验证
  validation: {
    validData: '有效数据',
    invalidData: '无效数据',
    dataCount: '{count} 条',
    errorReasons: {
      missingRequired: '缺少必填字段',
      invalidCodeFormat: '编码格式无效',
      parentNotFound: '未找到上级部门: {code}',
    },
  },

  // 操作按钮
  actions: {
    cancel: '取消',
    confirm: '开始导入',
    confirmWithCount: '开始导入 ({count} 条)',
    importing: '导入中...',
  },

  // 消息提示
  messages: {
    noValidData: '没有有效数据可导入',
    importSuccess: '成功导入 {count} 个部门',
    importPartial: '导入完成：成功 {success} 个，失败 {failed} 个',
    importFailed: '导入失败',
  },

  // 导入相关
  import: {
    selectFile: '请选择导入文件',
    selectOrg: '请先选择组织',
    importSuccess: '导入成功',
    importFailed: '导入失败',
    developing: '功能开发中',
    noValidData: '没有有效数据可导入',
  },
};

